require('./globalPositionTotalBalance.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const Immutable = require('immutable');

// @commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @constants
const { EURO_TEXT, OPENBANK_PRODUCT_BANKING, OPENBANK_PRODUCT_WEALTH } = require('constants/index');

class GlobalPositionTotalBalance extends React.Component {

    calculateFinalEURAmount (immAmounts, keepSign) {
        let amount = 0;
        if (immAmounts) {
            amount = typeof immAmounts === 'number' ? immAmounts : immAmounts.map(amountObject => {
                if (amountObject.get('currency') !== EURO_TEXT) {
                    /**
                     * Here we should make currency convertion
                     */
                    return amountObject.get('amount') * 1;
                }
                return amountObject.get('amount');
            }).reduce((prev, next) => prev + next );
        }

        return Immutable.fromJS({
            amount: keepSign ? amount : Math.abs(amount),
            currency: EURO_TEXT
        });
    }

    render () {
        const {translationKey, iconClass, immAmounts, keepSign, product} = this.props;
        const amountObject = this.calculateFinalEURAmount(immAmounts, keepSign);
        const plainAmountObject = getPlainAmountObject(amountObject);
        const totalBalanceClasses = classnames(
            'row global-position-total-balance',
            {
                [`global-position-total-balance--${product}`]: !!product,
            }
        );

        const globalPositionClassName = contactCenterClassName('global-position-total-balance__nofloat', 'col-xs-12')
        return (
            <div className={globalPositionClassName}>
                <div className={totalBalanceClasses}>
                    <div className="col-xs-12 col-sm-6 global-position-total-balance__left-column">
                        <FormattedText
                            value={translationKey}
                            className="global-position-total-balance__label"
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 global-position-total-balance__right-column">
                        <span className={iconClass}></span>
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            className="global-position-total-balance__amount"
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

GlobalPositionTotalBalance.propTypes = {
    translationKey: PropTypes.string.isRequired,
    immAmounts: PropTypes.any.isRequired,
    iconClass: PropTypes.string.isRequired,
    keepSign: PropTypes.bool,
    product: PropTypes.oneOf([ // If none specified it uses banking style
        OPENBANK_PRODUCT_BANKING,
        OPENBANK_PRODUCT_WEALTH
    ]),
}

module.exports = GlobalPositionTotalBalance;
